import { ReduxStore } from 'store/types';

function removeIsLoading(state: ReduxStore): boolean {
  return state.product.remove.config.isLoading;
}

export default removeIsLoading;
